import md5 from "js-md5/src/md5.js";

export default file => {
	return new Promise((success, failure) => {
		const reader = new FileReader();
		reader.onload = e => {
			const data = new Uint8Array(e.target.result);
			success(md5(data));
		}

		// an unreadable file must not stall the whole batch
		reader.onerror = () => failure(reader.error || new Error("The file could not be read"));
		reader.readAsArrayBuffer(file);
	});
};